import {
  DefaultAvatarSelectionPlugin,
  DefaultChatPlugin,
  DefaultHUDPlugin,
  Networked3dWebExperienceClient,
} from "@mml-io/3d-web-experience-client";

import loadingBackground from "../../../assets/images/loading-bg.jpg";
import airAnimationFileUrl from "../../../assets/models/anim_air.glb";
import doubleJumpAnimationFileUrl from "../../../assets/models/anim_double_jump.glb";
import glideAnimationFileUrl from "../../../assets/models/anim_glide.glb";
import idleAnimationFileUrl from "../../../assets/models/anim_idle.glb";
import jogAnimationFileUrl from "../../../assets/models/anim_jog.glb";
import sprintAnimationFileUrl from "../../../assets/models/anim_run.glb";

const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
const host = window.location.host;
const userNetworkAddress = `${protocol}//${host}/network`;

const holder = Networked3dWebExperienceClient.createFullscreenHolder();
const app = new Networked3dWebExperienceClient(holder, {
  sessionToken: (window as any).SESSION_TOKEN,
  userNetworkAddress,
  waitForWorldConfig: true,
  animationConfig: {
    airAnimationFileUrl,
    glideAnimationFileUrl,
    idleAnimationFileUrl,
    jogAnimationFileUrl,
    sprintAnimationFileUrl,
    doubleJumpAnimationFileUrl,
  },
  loadingScreen: {
    background: "#424242",
    color: "#ffffff",
    backgroundImageUrl: loadingBackground,
    backgroundBlurAmount: 12,
    title: "Pixel Sensei Test Zone",
    subtitle: "Powered by Metaverse Markup Language",
  },
  plugins: [new DefaultChatPlugin(), new DefaultAvatarSelectionPlugin(), new DefaultHUDPlugin()],
});

app.update();
